import React from 'react';

/**
 * White card wrapper for Solar/Wind maps (Renewable Potential tab).
 * Matches the Overview-tab-style layout; not the shared CountryDashboard shadow-card ChartCard.
 */
const RenewablePotentialChartCard = ({
  title,
  subtitle,
  children,
  icon,
  showHeader = true,
}) => (
  <div className="w-full min-w-0 overflow-hidden bg-white rounded-lg hover:shadow-sm transition-shadow">
    {showHeader && (
      <div className="flex justify-between items-center gap-2 p-2 sm:p-3 md:p-3 lg:p-4">
        <div className="min-w-0 flex-1 pr-1">
          <h3 className="text-sm sm:text-base font-semibold text-gray-900 mb-0.5 sm:mb-1 break-words">
            {title}
          </h3>
          {subtitle ? (
            <p className="text-xs text-gray-600 break-words">{subtitle}</p>
          ) : null}
        </div>
        {icon && (
          <div className="flex-shrink-0 text-gray-400 hover:text-gray-600 cursor-pointer">
            {icon}
          </div>
        )}
      </div>
    )}
    <div className="chart-container w-full min-w-0 overflow-hidden">{children}</div>
  </div>
);

export default RenewablePotentialChartCard;
